import { IonCol, IonGrid, IonIcon, IonItem, IonLabel, IonList, IonRow } from "@ionic/react";
import { checkmarkCircleOutline } from "ionicons/icons";

export const bewohnerlisteErstellen = ( modus:string, bewohner: any, my_link_root: string, my_onclick: (entry: any, index?: number) => void, bestellstatus?:any ) => {
  let my_bewohner = bewohner.map((entry: any, index: number) => {
    let my_bewohner_link =
      <IonItem
        button
        key={"bewohner_" + entry.betriebe_bewohner_id}
        routerLink={`${my_link_root}/${entry.betriebe_bewohner_id}/${entry.betriebe_bewohner_nachname}_${entry.betriebe_bewohner_vorname}`}
        onClick={() => my_onclick(entry,index)}
      >
        <IonLabel>
          {entry.betriebe_bewohner_nachname}, {entry.betriebe_bewohner_vorname} ({entry.betriebe_bewohner_raum})
        </IonLabel>
      </IonItem>
    ;
    if( modus === 'ist' ) return my_bewohner_link ;
    if( modus === 'soll' ) {
      let my_date_cols = [] ;
      for( let i = 1; i <= 4; i++ ) {
        let my_state = bestellstatus[ i ].includes( parseInt( entry.betriebe_bewohner_id ) ) ? <IonIcon color="success" icon={ checkmarkCircleOutline } /> : '...' ;
        my_date_cols.push( <IonCol key={ "date_col_" + i } style={{textAlign:'center'}}>{ my_state }</IonCol> ) ;
      }
      return (
        <IonRow key={ "date_row_" + index }>
          <IonCol key="col_bewohner" size="3">
            { my_bewohner_link }
          </IonCol>
          { my_date_cols }
        </IonRow>
      )
    }
  });
  if( modus === 'ist' ) return <IonList>{my_bewohner}</IonList> ;
  if( modus === 'soll' ) return <IonGrid>{my_bewohner}</IonGrid> ;
}
